module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-alt-choice-container cmd-side-container",
    class: _vm.cssClasses
  }, _vm._l((_vm.options), function(value, valueRef) {
    return (value.display) ? _c('label', {
      staticClass: "selection-alt-choice-container-item",
      class: {
        'selected': (_vm.selected === valueRef)
      },
      attrs: {
        "value": valueRef,
        "for": valueRef,
        "disabled": value.disabled
      }
    }, [_c('div', {
      staticClass: "selection-alt-choice-picture-container"
    }, [_c('div', {
      staticClass: "txt-button",
      domProps: {
        "textContent": _vm._s(value.label)
      }
    }), (value.display) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "radio",
        "id": valueRef,
        "name": valueRef,
        "disabled": value.disabled
      },
      domProps: {
        "value": valueRef,
        "checked": _vm._q(_vm.selected, valueRef)
      },
      on: {
        "change": function($event) {
          _vm.selected = valueRef
        }
      }
    }) : _vm._e()])]) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20b6db3c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/inputs/unique_choice/SelectWithTextComponent.vue
// module id = 335
// module chunks = 1